import { useMutation, useQueryClient } from '@tanstack/react-query';

import { addEmployee } from '@entities/myTeam/api/addEmployee';

export const useAddEmployeeQuery = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ['addEmployee'],
        mutationFn: addEmployee,
        onSuccess: (res) => {
            if (res?.data?.status === 'success') {
                queryClient.invalidateQueries({ queryKey: ['myTeam'] });
            }
        },
    });
};
